import Swal, { SweetAlertIcon } from 'sweetalert2';
import { KeyString } from '../constants/types';

type ConfirmAlertOptions = {
	message: string,
	type?: SweetAlertIcon,
	msgConfirm?: string,
	callBack?: Function,
	callBackError?: Function,
	customClass?: string,
	showCancelButton?: boolean,
	dismissible?: boolean,
}

export const showAlert = (message: string, callBack?: Function, type: SweetAlertIcon = 'success') => {
	let title = type === 'success' ? '¡Operación exitosa!' : '¡Ocurrió un error!';
	title = type === 'info' ? '¡Atención!' : title;

	Swal.fire({
		title,
		html: message,
		confirmButtonText: 'Aceptar',
		confirmButtonColor: '#335d4e',
		icon: type,
	}).then(() => {
		if (callBack) {
			callBack();
		}
	});
};

export const showCustomAlert = ({
	message,
	title = '¡Atención!',
	type = 'success',
	iconHtml,
	callBack,
	confirmButtonText,
}: {
	message: string;
	title: string;
	callBack?: Function;
	type?: SweetAlertIcon;
	iconHtml?: string,
	confirmButtonText?: string;
}) => {
	Swal.fire({
		title,
		html: message,
		confirmButtonText: confirmButtonText ?? 'Aceptar',
		confirmButtonColor: '#335d4e',
		icon: !!iconHtml ? undefined : type,
		iconHtml: iconHtml,
	}).then(() => {
		if (callBack) {
			callBack();
		}
	});
};

/**
 * @description Alerta para confirmación, dos botones, aceptar - cancelar
 * @param options Configuración de la alerta
 * @param options.message Mensaje a mostrar en la alerta
 * @param options.callBack Funcion ejecutada al aceptar
 * @param options.type Tipo de alerta
 * @param options.msgConfirm Mensaje para el botón de confirmación
 * @param options.callBackError Callback ejecutado al cancelar
 * @param options.customClass Clase del body del alert
 * @param options.showCancelButton Mostrar botón de cancelar
 * @param options.dismissible Permitir cerrar la alerta haciendo click fuera de ella
 */
export const showConfirmAlert = ({
	message,
	callBack,
	type = 'info',
	msgConfirm = 'Aceptar',
	callBackError,
	customClass,
	showCancelButton = true,
	dismissible = true,
}: ConfirmAlertOptions) => {
	const messageByType: KeyString = {
		success: '¡Operación exitosa!',
		danger: '¡Ocurrió un error!',
		info: '¡Atención!',
	};
	const title = messageByType[type.toString()] ?? messageByType['info'];

	Swal.fire({
		title,
		html: message,
		showCancelButton: showCancelButton,
		allowOutsideClick: dismissible,
		allowEscapeKey: dismissible,
		confirmButtonText: msgConfirm,
		cancelButtonText: 'Cancelar',
		confirmButtonColor: '#335d4e',
		cancelButtonColor: '#f7a40c',
		icon: type,
		customClass,
	}).then((result) => {
		if (result.isConfirmed) {
			if (callBack) {
				callBack();
			}
		}else{
			if (callBackError) {
				callBackError();
			}
		}
	});
};
export const showAlertDimeter = (
	message: string,
	timer= 5000,
	timerProgressBar= false,
	callBack?: Function,
	type: SweetAlertIcon = 'success',
) => {
	const Toast = Swal.mixin({
		toast: true,
		position: 'top',
		showConfirmButton: false,
		timer: timer,
		timerProgressBar: timerProgressBar,
		didOpen: (toast) => {
			toast.onmouseenter = Swal.stopTimer;
			toast.onmouseleave = Swal.resumeTimer;
		},
	});
	Toast.fire({
		icon: type,
		title: message,
	}).then(() => {
		if (callBack) {
			callBack();
		}
	});;
};
